/** The unit an order's exact dimensions are given in. */
export enum DimensionUnit {
	PIXELS = 'px',
	INCHES = 'in',
}

/** Whether a legal text applies to a piece, as its distribution package states it. */
export enum LegalApplicability {
	APPLICABLE = 'applicable',
	NOT_APPLICABLE = 'not_applicable',
	UNKNOWN = 'unknown',
}

/** The broad kind of work an asset type belongs to. */
export enum WorkType {
	PRINT = 'print',
	DIGITAL = 'digital',
	VIDEO = 'video',
}
